class Errors {
    /**
     * Create a new Errors instance.
     */
    constructor() {
        this.errors = {};
    }


    /**
     * Determine if an errors exists for the given field.
     *
     * @param {string} field
     */
    has(field) {
        return this.errors.hasOwnProperty(field);
    }


    /**
     * Determine if we have any errors.
     */
    any() {
        return Object.keys(this.errors).length > 0;
    }


    /**
     * Retrieve the error message for a field.
     *
     * @param {string} field
     */
    get(field) {
        if (this.errors[field]) {
            return this.errors[field][0];
        }
    }

    /**
     * Sets the error message for a field.
     *
     * @param field
     * @param message
     */
    set(field, message) {
        this.errors[field] = message;
    }

    /**
     * Record the new errors.
     *
     * @param {object} errors
     */
    record(errors) {
        let newKey = "";
        let newValue = "";
        let newErrorsObject = {};

        for( let k in errors.errors){
            newValue = errors.errors[k][0];
            newKey = k.replace( /\./g, '_' );
            newErrorsObject[newKey] = newValue;
        }
        this.errors = newErrorsObject;
    }


    /**
     * Clear one or all error fields.
     *
     * @param {string|null} field
     */
    clear(field = null) {
        if (field) {
            delete this.errors[field];

            return;
        }

        this.errors = {};
    }

    /**
     * Returns all recorded errors.
     *
     * @returns {*}
     */
    all() {
        return this.errors;
    }
}

export default Errors;
